export const faqs = [
  {
    q: 'Is this system designed for private security professionals?',
    a: "Yes. The prompts are organized around common private security documentation, site operations, shift handovers, risk observations, communication, and supervisory tasks. You should adapt them to your role, site requirements, and employer's procedures.",
  },
  {
    q: 'Do I need to be a technology expert?',
    a: 'No advanced AI skills are required to get started. The prompts provide structured instructions and customizable fields. You will still need to supply accurate information and review the output.',
  },
  {
    q: 'Which AI assistants can I use?',
    a: 'You can use the prompts with compatible AI assistants that accept text instructions, including ChatGPT, Claude, Gemini, and other suitable services. Features, access, privacy terms, and usage limits depend on the service you choose.',
  },
  {
    q: 'Will the AI-generated reports always be correct?',
    a: "No. AI can misunderstand information, omit details, or generate inaccurate statements. Always verify the output against your source records and follow your organization's reporting procedures.",
  },
  {
    q: 'Is it safe to enter confidential security information?',
    a: "You should never assume that any AI platform is automatically appropriate for confidential information. Review the provider's privacy terms and your employer's policies before using sensitive data. Use anonymized or fictional examples whenever possible, and do not enter restricted information without proper authorization.",
  },
  {
    q: "Does this system replace my employer's procedures or professional training?",
    a: 'No. The toolkit is intended to support drafting, organization, and routine administrative workflows. It does not replace professional judgment, required training, company policies, site-specific instructions, or applicable laws and regulations.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'The advertised price for the main product is $27 USD as a one-time payment. No recurring subscription is included in this offer. Confirm the final checkout terms before purchasing.',
  },
  {
    q: 'What do I receive with my purchase?',
    a: 'You receive the six-volume 100+ AI PROMPTS FOR PRIVATE SECURITY™ system, containing 120 prompts, plus all four complementary bonuses: The Security Report Template Vault™, The Shift Handover Toolkit™, The Professional Security Communication Kit™, and The AI Workflow Quickstart Guide.',
  },
  {
    q: 'How do I access the materials?',
    a: 'The product is delivered digitally. Follow the instructions provided after checkout to access your files. The actual delivery method and available formats are determined by the configured checkout.',
  },
  {
    q: 'Is there a refund guarantee?',
    a: 'The offer includes a seven-day money-back guarantee, subject to the applicable purchase and refund terms. Review those terms at checkout and contact support if you need assistance with a refund request.',
  },
  {
    q: 'Who should consider this toolkit?',
    a: 'It may be useful for private security officers, supervisors, site managers, team leaders, and security business operators who regularly prepare documentation or coordinate routine operational tasks.',
  },
];
